/**
 * URL-param parsing — mirrors
 *   packages/amgdragontiger_v2/lib/core/utils/url_params.dart
 * (web branch only; no LocalStorage path)
 */
import { DEFAULT_AGENT_ID, DEFAULT_USER_NAME } from '../config';

export interface UrlParams {
  token: string | null;
  gsid: string | null;
  userName: string;
  agentId: string;
  isSound: boolean;
  exitUrl: string | null;
}

export function loadUrlParams(): UrlParams {
  const q = new URLSearchParams(window.location.search);
  return {
    token: q.get('token'),
    gsid: q.get('gsid'),
    userName: q.get('user') ?? q.get('userName') ?? DEFAULT_USER_NAME,
    agentId: q.get('agentId') ?? DEFAULT_AGENT_ID,
    isSound: q.get('isSound') === 'true' || q.get('isSound') === '1',
    exitUrl: q.get('exitUrl'),
  };
}
